import React, { useState } from 'react';
import './Login.css';
import { Mail, Lock, Eye, EyeOff, LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { handlePostApi } from '../../api/api';
import Cookies from 'js-cookie';

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      username: email,
      password
    }
    const res = await handlePostApi('admin/login', data, {})
    console.log(res)
    if(res.success === false){
      alert(res.message)
      setLoading(false)
    }
    if(res.success === true){
      Cookies.set('auth_token', JSON.stringify(res.token))
      navigate('/dashboard')
    }
  };

  return (
    <div className="login-container">
      <div className="login-overlay"></div>
      
      <div className="login-card-wrapper fade-in">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-section">
              <div className="logo-icon">R</div>
              <h1 className="brand-name">OYAL<span>FURNISHERS</span></h1>
            </div>
            <p className="subtitle">Welcome back. Please enter your details.</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <label>Username</label>
              <div className="input-wrapper">
                <Mail className="input-icon" size={20} />
                <input 
                  type="text" 
                  placeholder="admin@luxe.com" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="input-group">
              <label>Password</label>
              <div className="input-wrapper">
                <Lock className="input-icon" size={20} />
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="••••••••" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button 
                  type="button" 
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <button type="submit" className={`submit-btn ${loading ? 'loading' : ''}`} disabled={loading}>
              {loading ? (
                <div className="spinner"></div>
              ) : (
                <>
                  <span>Sign In</span>
                  <LogIn size={20} />
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>&copy; 2026 Royal Furnisher Admin Panel. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
